/* v8 ignore start -- @preserve */
import { v4 as uuidv4 } from "uuid";

import { Skeleton } from "@vega-core/components/shadcn/skeleton";

type Props = {
  itemCount?: number;
  showUser?: boolean;
};

export const NavbarSkeleton = ({ itemCount = 2, showUser = true }: Props) => (
  <div className="flex items-center gap-4" data-testid="navbar-skeleton">
    <div className="flex items-center gap-4">
      {Array.from({ length: itemCount }).map(() => (
        <Skeleton className="h-8 w-8 rounded-full" key={uuidv4()} />
      ))}
    </div>
    {showUser ? (
      <>
        <div className="h-6 w-px bg-border/primary mx-2" />
        <div className="flex items-center gap-2">
          <Skeleton className="h-8 w-8 rounded-full" />
          <Skeleton className="h-4 w-24" />
        </div>
      </>
    ) : null}
  </div>
);
